import { TFunction } from 'i18next';
import { IErrorResponse, IMessage } from '~/Models/DTO/Error.models';

const mapKey = (key: string) => {
  switch (key) {
    case 'invalid_request':
    case 'invalid_grant':
      return 'userService.invalidCredentials';
    default:
      return key;
  }
};

const messageFromErrors = (errors: string[] | IMessage[], t?: TFunction) => {
  if (typeof errors?.[0] !== 'string') {
    return messageFromTranslatableMessages(errors as IMessage[], t);
  }
  if (errors?.length) {
    return errors[0];
  } else {
    try {
      return JSON.stringify(errors as any);
    } catch (e) {
      return 'app.error';
    }
  }
};

export const messageFromTranslatableMessages = (
  translatableMessages: IMessage[],
  t?: TFunction,
) => {
  if (translatableMessages && translatableMessages.length > 0) {
    return translatableMessages
      .map((message) => {
        if (!message.key) {
          return message.defaultMessage;
        }
        if (t) {
          const ErrorKey = mapKey(message.key);
          const errorMessage = t(ErrorKey);
          if (errorMessage === ErrorKey) {
            return message.defaultMessage;
          }
          return errorMessage;
        }
        return message?.defaultMessage || 'app.default.error';
      })
      .join('<br />');
  }

  return 'app.error';
};

export const extractErrorMessage = (errorObj: IErrorResponse | undefined | null, t?: TFunction) => {
  if (!errorObj) {
    return null;
  }

  if (typeof errorObj === 'string') {
    return errorObj;
  }

  if (errorObj.errors) {
    return messageFromErrors(errorObj.errors, t);
  }

  if (errorObj.messages) {
    return messageFromTranslatableMessages(errorObj.messages, t);
  }

  if (errorObj.message) {
    return errorObj.message;
  }

  if (errorObj.error_description && errorObj.error) {
    const ErrorKey = mapKey(errorObj.error_description);
    const errorMessage = t?.(ErrorKey);
    if (errorMessage === ErrorKey) {
      return errorObj.error;
    }
    return errorMessage;
  }

  if (errorObj.error) {
    return errorObj.error;
  }

  return null;
};
